import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';
import { ServerError, createApiError } from 'stores/ApiClientError';

// --- 型定義 ---

/** コメント返信（子コメント） */
export type TicketCommentReplyResult = {
  commentId: string;
  comment: string;
  createdBy: string;
  createdByName: string;
  createdAt: string;
};

/** コメント（親・返信リスト付き） */
export type TicketCommentResult = {
  commentId: string;
  comment: string;
  createdBy: string;
  createdByName: string;
  createdAt: string;
  replies: TicketCommentReplyResult[];
};

// --- リクエスト型 ---

/** コメント登録（API7131） */
export type CreateTicketCommentParams = {
  ticketId: string;
  comment: string;
  parentCommentId?: string;
};

/** コメント一覧取得（API7132） */
export type ListTicketCommentParams = {
  ticketId: string;
};

// --- 共通 ---
const authHeader = () => ({
  headers: { 'X-Session-Id': localStorage.getItem('session-id') },
});

const handleError = (error: unknown): never => {
  if (axios.isAxiosError(error) && error.response) {
    const { status, data } = error.response;
    throw createApiError(status, data?.message || error.message);
  }
  throw new ServerError();
};

// --- API関数 ---

/**
 * コメント登録API (API7131)
 * @param params.ticketId - チケットID（必須, 最大64文字）
 * @param params.comment - コメント（必須, 最大10000文字）
 * @param params.parentCommentId - 親コメントID（任意, 返信先。2段階まで）
 */
export const createTicketComment = async (params: CreateTicketCommentParams): Promise<string> => {
  try {
    const response = await axios.post(KanzhongBackend.CREATE_TICKET_COMMENT, params, authHeader());
    return response.data.commentId;
  } catch (error) {
    return handleError(error);
  }
};

/**
 * コメント一覧取得API (API7132)
 * @param params.ticketId - チケットID（必須, 最大64文字）
 */
export const listTicketComment = async (
  params: ListTicketCommentParams,
): Promise<TicketCommentResult[]> => {
  try {
    const response = await axios.post(KanzhongBackend.LIST_TICKET_COMMENT, params, authHeader());
    return response.data.results ?? [];
  } catch (error) {
    return handleError(error);
  }
};
